import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {AuthorizationService} from './authorization.service';
import {environment} from '../environments/enviroment';

interface PasswordChangeRequest {
  email: string;
  workspace_id: string;
  current_password: string;
  new_password: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {
  private readonly changePasswordUrl = `${environment.mindxbkUrl}Agent/`;

  constructor(
    private http: HttpClient,
    private authService: AuthorizationService
  ) {
  }

  changePassword(email: string, currentPassword: string, newPassword: string, workspaceId?: string): Observable<any> {
    // Leer token directamente desde localStorage
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const resolvedWorkspaceId = (workspaceId || this.resolveWorkspaceId()).trim();
    if (!resolvedWorkspaceId) {
      return throwError(() => new Error('No workspace available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const body: PasswordChangeRequest = {
      email: email,
      workspace_id: resolvedWorkspaceId,
      current_password: currentPassword,
      new_password: newPassword
    };

    return this.http.post(
      `${this.changePasswordUrl}change-password`,
      body,
      {headers}
    );
  }

  changePasswordByAdmin(
    agent_id: string,
    newPassword: string
  ): Observable<any> {
    const token = localStorage.getItem('auth_req');
    if (!token) {
      console.error('❌ No se encontró token en localStorage (auth_req)');
      return throwError(() => new Error('No auth token available'));
    }

    const headers = new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const body = {
      agent_id: agent_id,
      password: newPassword
    };

    return this.http.patch(
      `${this.changePasswordUrl}change-agent-password`,
      body,
      {headers}
    );
  }

  private resolveWorkspaceId(): string {
    const raw = sessionStorage.getItem('workspace')
      || sessionStorage.getItem('workpsaceId')
      || sessionStorage.getItem('workspaceId')
      || localStorage.getItem('workspace')
      || localStorage.getItem('workpsaceId')
      || localStorage.getItem('workspaceId');

    if (!raw) {
      return '';
    }

    try {
      const workspace = JSON.parse(raw);
      return String(workspace?.id || workspace?.workspaceId || '').trim();
    } catch {
      return '';
    }
  }

}
